
import { defineComponent, ref } from 'vue';
import LPExplainVideo from '@/views/public/landingpage/components/LPExplainVideo.vue';
import FreelancerLogo from '@/views/public/landingpage/components/freelancer/FreelancerLogo.vue';
import FreelancerWelcome from '@/views/public/landingpage/components/freelancer/FreelancerWelcome.vue';
import FreelancerFeatures from '@/views/public/landingpage/components/freelancer/FreelancerFeatures.vue';
import BgImage from '@/views/public/landingpage/components/freelancer/BgImage.vue';
import FreelancerInvitation from '@/views/public/landingpage/components/freelancer/FreelancerInvitation.vue';
import LPUserCarousel from '@/views/public/landingpage/components/user-carousel/LPUserCarousel.vue';

export default defineComponent({
  name: 'LandingpageFreelancer',
  components: {
    LPUserCarousel,
    FreelancerInvitation,
    BgImage,
    FreelancerFeatures,
    FreelancerWelcome,
    FreelancerLogo,
    LPExplainVideo,
  },
  setup() {
    const isUserCarouselVisible = ref(false);

    return {
      isUserCarouselVisible
    };
  }
});
